<div #chartdiv class="barchart"></div>
